// extracted by mini-css-extract-plugin
export default {"item":"ProjectSlider_item__ycAiw","subItem":"ProjectSlider_subItem__dTsgz"};